import React from 'react';
import PropTypes from 'prop-types';
import { Form, Field, withFormik } from 'formik';
import * as yup from 'yup';
import axios from 'axios';

import TutoriumInput from '../../form/TutoriumInput';
import AuthSubmitButton from '../common/AuthSubmitButton';

import Alert from '../../common/Alert';

const mapPropsToValues = () => ({ username: '' });

const validationSchema = yup.object().shape({
  username: yup
    .string()
    .email()
    .required(),
});

const handleSubmit = async (values, bag) => {
  bag.setSubmitting(true);
  try {
    const response = await axios.post('/api/v1/auth/sendResetPasswordMessage', { username: values.username });

    if (response.data.success) {
      bag.setStatus({ isFail: false });
    } else {
      bag.setStatus({ isFail: true, errorMessage: response.data.errorMessage });
    }
  } catch (e) {
    bag.setStatus({ isFail: true, errorMessage: e.response.data.errorMessage });
  }

  bag.setSubmitting(false);
};

const ForgotPasswordForm = props => {
  return (
    <Form noValidate>
      {props.status && props.status.isFail === false && <Alert message="Message has been sent" isSuccess isSmall />}
      {props.status && props.status.isFail === true && <Alert message="An unknown error occured" isError isSmall />}
      <Field name="username" type="email" placeholder="Email" component={TutoriumInput} />
      <AuthSubmitButton title="Send" isSubmitting={props.isSubmitting} />
    </Form>
  );
};

ForgotPasswordForm.propTypes = {
  isSubmitting: PropTypes.bool.isRequired,
  status: PropTypes.object,
};

export default withFormik({
  mapPropsToValues,
  validationSchema,
  handleSubmit,
})(ForgotPasswordForm);
